
import { Component, Vue } from "vue-property-decorator";

@Component
export default class IconCartOk extends Vue {
  sData: string = require("@icon/lineicons/shopping-cart-8.svg");
}
